import EditableConnected from './EditableConnected'

export default EditableConnected
